import Button from "../../components/Button/Button";
import FlexLayout from "../../components/FlexLayout/FlexLayout";
import Icon from "../../components/Icon/Icon";
import Toast from "../../components/Toast/Toast";
import useOnMount from "../../libs/hooks/use-on-mount";
import { useCommonAppDispatcher } from "../../store/hooks";
import { ToastActionProps } from "../../store/slices/toasts";

interface Props {
  toast: ToastActionProps & { id: string };
}

const ToastItemPartial = ({ toast }: Props) => {
  const [dispatch, actions] = useCommonAppDispatcher();

  const handleClose = () => {
    dispatch(actions.toasts.hideToast({ id: toast.id }));
    toast.onClose?.();
  };

  useOnMount(() => {
    let timeoutRef: NodeJS.Timeout;

    if (toast.timeout) {
      timeoutRef = setTimeout(() => {
        handleClose();
      }, toast.timeout);
    }

    return () => {
      if (timeoutRef) {
        clearTimeout(timeoutRef);
      }
    };
  });

  const dispatchActionCallback = (action?: ToastActionProps["primaryAction"]) => {
    handleClose();

    const actionCallback = action?.callback();
    if (actionCallback) {
      dispatch(actionCallback);
    }
  };

  const renderToastActions = (toast: ToastActionProps) => {
    if (toast.primaryAction && !toast.secondaryAction) {
      return (
        <Button size="s" onClick={() => dispatchActionCallback(toast.primaryAction)}>
          {toast.primaryAction.label}
        </Button>
      );
    } else if (toast.primaryAction && toast.secondaryAction) {
      return (
        <FlexLayout gap="s">
          <Button size="s" onClick={() => dispatchActionCallback(toast.primaryAction)}>
            {toast.primaryAction.label}
          </Button>
          <Button size="s" onClick={() => dispatchActionCallback(toast.secondaryAction)}>
            {toast.secondaryAction.label}
          </Button>
        </FlexLayout>
      );
    } else {
      return undefined;
    }
  };

  return (
    <Toast
      id={toast.id}
      title={toast.title}
      description={toast.description}
      icon={toast.icon && <Icon source={toast.icon} />}
      kind={toast.kind}
      timeout={toast.timeout}
      permanent={toast.permanent}
      shouldInteractionLeaveKeyboardOpen={toast.shouldInteractionLeaveKeyboardOpen}
      onClose={handleClose}
      action={renderToastActions(toast)}
    />
  );
};

export default ToastItemPartial;
